export const GET_ALL_BANNERS = "GET_ALL_BANNERS";
export const GET_ALL_BANNERS_RESPONSE_SUCCESS =
  "GET_ALL_BANNERS_RESPONSE_SUCCESS";
